import React, {createContext, useContext} from "react"
import {useTranslation} from "react-i18next"
import {ProgressIndicator} from "../../app/ProgressIndicator"

const EventsTranslationContext = createContext(undefined)

export const EventsTranslationProvider = ({children}) => {
    const {t, ready} = useTranslation("bpn.events", {useSuspense: false})

    if (ready) {
        return (
            <EventsTranslationContext.Provider value={t}>
                {children}
            </EventsTranslationContext.Provider>
        )
    } else {
        return <ProgressIndicator/>
    }
}

export const useEventsTranslation = () => {
    return useContext(EventsTranslationContext)
}